<template>
  <div>
    <CycleCopy></CycleCopy>
  </div>
</template>

<script>
import CycleCopy from "@/components/CycleCopy/index.vue";
export default {
  components: {
    CycleCopy,
  },
};
</script>

<style></style>
